import { IconFromSet } from "@cmp-src/icons";

import type { FeatureItemProps } from "./types";

export const FeatureItem: React.FC<FeatureItemProps> = ({
  icon,
  title,
  description,
  theme
}) => (
  <div className="flex items-start gap-3 rounded-xl border border-neutral-100 bg-neutral-50 p-3">
    <div
      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br ${theme.featureIconBg} ${theme.featureIconText}`}
    >
      <IconFromSet icon={icon} size={4} />
    </div>
    <div className="min-w-0 flex-1">
      <h3 className="font-medium text-[#0F2449] text-sm">{title}</h3>
      <p className="mt-0.5 text-content text-xs">{description}</p>
    </div>
  </div>
);
